import { phase3FlowConfig } from './flow'
import { phase3MasterUpdateConfig } from './masterUpdate'
import { phase3TokenRefreshConfig } from './tokenRefresh'

/**
 * Phase 3: 定常実行フェーズ（parallel state）
 *
 * flow（ダイアログフロー → appReady）/ tokenRefresh（定期リフレッシュ）/
 * masterUpdate（マスタデータ定期更新）の 3 つのサブコンフィグを parallel で実行する。
 * LOGOUT イベントまたはトークンリフレッシュ失敗で loggedOut に遷移する。
 */
export const phase3Config = {
  type: 'parallel' as const,
  on: {
    LOGOUT: {
      target: '#lifecycle.loggedOut' as const,
      actions: 'clearToken' as const,
    },
  },
  states: {
    flow: phase3FlowConfig,
    tokenRefresh: phase3TokenRefreshConfig,
    masterUpdate: phase3MasterUpdateConfig,
  },
}
